import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useIsAdminApp } from "./useStandalone";
import { hasAdminAccess, hasTrainerAccess } from "../utils/roles";
import { useIsMobile } from "./useMediaQuery";

/** Admin or trainer hub layout (all viewports). */
export function useAdminAppMode() {
  const role = useSelector((state) => state.auth.role);
  const { pathname } = useLocation();
  const inStaffHub =
    pathname.startsWith("/staff/app") && hasTrainerAccess(role);
  const inAdminHub =
    pathname.startsWith("/manage/app") && hasAdminAccess(role);
  return useIsAdminApp(inStaffHub || inAdminHub);
}

/** Mobile PWA chrome for /manage/app and /staff/app. Desktop uses ManageDesktopShell. */
export function useAdminHubUi() {
  const inHub = useAdminAppMode();
  const isMobile = useIsMobile(768);
  return inHub && isMobile;
}

export function useStaffAppMode() {
  const role = useSelector((state) => state.auth.role);
  return useIsAdminApp(hasTrainerAccess(role));
}
